"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SprojsPanel;

var _react = require("@chakra-ui/react");

var _react2 = _interopRequireWildcard(require("react"));

var _admin = require("../../context/admin");

var _constants = require("../../utils/constants");

var _sliderFormControl = _interopRequireDefault(require("../slider-form-control"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SPROJS_SIZE_OPTIONS = [_constants.SPROJS_SIZE_REGULAR, _constants.SPROJS_SIZE_THICK];
var DEFAULT_ENKEL_SPROJS_Y = 250;

function SprojsPanel(props) {
  var _value$enkel;

  var value = props.value,
      maxX = props.maxX,
      _onChange = props.onChange;
  var admin = (0, _react2.useContext)(_admin.AdminContext);
  var xError = (0, _react2.useMemo)(function () {
    if (value.x > maxX) return "Max antal spröjs är " + maxX;
  }, [value.x, maxX]);
  return /*#__PURE__*/_react2.default.createElement(_react.Stack, {
    direction: "column",
    spacing: 4
  }, /*#__PURE__*/_react2.default.createElement(_react.Checkbox, {
    isChecked: value.romb,
    onChange: function onChange(e) {
      return _onChange(_objectSpread(_objectSpread({}, value), {}, {
        romb: Boolean(e.target.checked)
      }));
    }
  }, "Rombspr\xF6jsning"), /*#__PURE__*/_react2.default.createElement(_sliderFormControl.default, {
    label: "Liggande spr\xF6js",
    value: value.y,
    isDisabled: value.romb,
    min: 0,
    max: 8,
    step: 1,
    onChange: function onChange(y) {
      return _onChange(_objectSpread(_objectSpread({}, value), {}, {
        y: y
      }));
    }
  }), /*#__PURE__*/_react2.default.createElement(_sliderFormControl.default, {
    label: "St\xE5ende spr\xF6js",
    value: value.x,
    isDisabled: value.romb,
    min: 0,
    max: 8,
    step: 1,
    error: xError,
    onChange: function onChange(x) {
      return _onChange(_objectSpread(_objectSpread({}, value), {}, {
        x: x
      }));
    }
  }), admin ? /*#__PURE__*/_react2.default.createElement(_react2.default.Fragment, null, /*#__PURE__*/_react2.default.createElement(_react.FormControl, null, /*#__PURE__*/_react2.default.createElement(_react.FormLabel, null, "Tjocklek liggande"), /*#__PURE__*/_react2.default.createElement(_react.RadioGroup, {
    onChange: function onChange(size) {
      return _onChange(_objectSpread(_objectSpread({}, value), {}, {
        size: _objectSpread(_objectSpread({}, value.size), {}, {
          y: parseFloat(size)
        })
      }));
    },
    value: value.size.y
  }, /*#__PURE__*/_react2.default.createElement(_react.Stack, {
    direction: "row",
    spacing: 4
  }, SPROJS_SIZE_OPTIONS.map(function (size) {
    return /*#__PURE__*/_react2.default.createElement(_react.Radio, {
      key: size,
      value: size
    }, size, " mm");
  })))), /*#__PURE__*/_react2.default.createElement(_react.FormControl, null, /*#__PURE__*/_react2.default.createElement(_react.FormLabel, null, "Tjocklek st\xE5ende"), /*#__PURE__*/_react2.default.createElement(_react.RadioGroup, {
    onChange: function onChange(size) {
      return _onChange(_objectSpread(_objectSpread({}, value), {}, {
        size: _objectSpread(_objectSpread({}, value.size), {}, {
          x: parseFloat(size)
        })
      }));
    },
    value: value.size.x
  }, /*#__PURE__*/_react2.default.createElement(_react.Stack, {
    direction: "row",
    spacing: 4
  }, SPROJS_SIZE_OPTIONS.map(function (size) {
    return /*#__PURE__*/_react2.default.createElement(_react.Radio, {
      key: size,
      value: size
    }, size, " mm");
  })))), /*#__PURE__*/_react2.default.createElement(_react.Checkbox, {
    isChecked: Boolean(value.enkel),
    onChange: function onChange(e) {
      return _onChange(_objectSpread(_objectSpread({}, value), {}, {
        enkel: Boolean(e.target.checked) && {
          y: DEFAULT_ENKEL_SPROJS_Y
        }
      }));
    }
  }, "Enkelspr\xF6js"), /*#__PURE__*/_react2.default.createElement(_react.FormControl, null, /*#__PURE__*/_react2.default.createElement(_react.FormLabel, null, "Enkelspr\xF6js h\xF6jd"), /*#__PURE__*/_react2.default.createElement(_react.NumberInput, {
    isDisabled: !value.enkel,
    value: (_value$enkel = value.enkel) === null || _value$enkel === void 0 ? void 0 : _value$enkel.y,
    min: 0,
    onChange: function onChange(_value, valueAsNumber) {
      return _onChange(_objectSpread(_objectSpread({}, value), {}, {
        enkel: {
          y: valueAsNumber || 0
        }
      }));
    },
    keepWithinRange: true,
    clampValueOnBlur: true,
    errorBorderColor: "orange.100"
  }, /*#__PURE__*/_react2.default.createElement(_react.NumberInputField, {
    placeholder: DEFAULT_ENKEL_SPROJS_Y
  }), /*#__PURE__*/_react2.default.createElement(_react.NumberInputStepper, null, /*#__PURE__*/_react2.default.createElement(_react.NumberIncrementStepper, null), /*#__PURE__*/_react2.default.createElement(_react.NumberDecrementStepper, null))), /*#__PURE__*/_react2.default.createElement(_react.FormHelperText, null, "Undersida b\xE5ge till \xF6vre spr\xF6js"))) : null);
}